import React, { useEffect, useState } from "react";
import axios from "axios";
import CategoriesList from "../../components/CategoriesList";
import SearchWidget from "../../components/SearchWidget";
import DateDisplay from "../../utils/dateDisplay";
import ShareArticle from "../../components/ShareArticle";
import Parser from "html-react-parser";
import RelatedPosts from "../../components/RelatedPosts";
import {Link, useParams} from "react-router-dom";
import Seo from "../../components/common/Seo";
import Header from "../../components/home-7/Header";
import FooterDefault from "../../components/footer/common-footer";
import WordpressApi2 from "../../lib/wordpressApi2";
import MobileMenu from "../../components/header/MobileMenu";
import LoaderAnimation from "../../lib/loaderAnimation";

export default function BlogSlug () {
    const { postSlug} = useParams();
    const [state, setState] = useState({
        post: null,
        loading: true,
        error: null,
    });

    const [relatedPosts, setRelatedPosts] = useState(null);
    const [categoryNames, setCategoryNames] = useState([]);
    const [tagNames, setTagNames] = useState([]);

    useEffect(() => {
        if (state.post) {
            document.title = Parser(state.post.title.rendered);
        }
    }, [state.post]);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const wpCategories = process.env.REACT_APP_WP_CATEGORIES;
                const url = `${process.env.REACT_APP_WP_API_URL_V2}/posts`;
                const response = await axios.get(
                    url,
                    {
                        params: {
                            _fields: [
                                'id',
                                'content',
                                'categories',
                                'title',
                                'date',
                                'featured_media',
                                'slug',
                                'author_info',
                                'status'
                            ],
                            slug: postSlug,
                            categories: wpCategories
                        }
                    }
                );

                if (response.data.length === 0) {
                    setState({
                        post: null,
                        loading: false,
                        error: "Article non trouvé",
                    });
                    return;
                }

                setState({
                    post: response.data[0],
                    loading: false,
                    error: null,
                });
            } catch (error) {
                console.error("Erreur lors de la récupération:", error);
                setState({
                    post: null,
                    loading: false,
                    error: "Erreur lors du chargement de l'article",
                });
            }
        };

        if (postSlug) {
            fetchPost();
        }
    }, [postSlug]);

    useEffect(() => {
        const fetchCategories = async () => {
            if (!state.post?.categories || state.post.categories.length === 0) return;

            try {
                const include = state.post.categories.join(",");
                const url = `${process.env.REACT_APP_WP_API_URL_V2}/categories?include=${include}`;
                const response = await fetch(url);
                const categories = await response.json();
                const categoryNames = categories.map((category) => category.name);
                setCategoryNames(categoryNames);
            } catch (error) {
                console.error("Erreur lors de la récupération des catégories :", error);
            }
        };

        if (state.post) {
            fetchCategories();
        }
    }, [state.post]);

    useEffect(() => {
        const fetchTags = async () => {
            if (!state.post?.tags || state.post.tags.length === 0) return;

            try {
                const url = `${process.env.REACT_APP_WP_API_URL_V2}/tags`;
                const response = await fetch(
                    url,
                    {
                        params: {
                            include : state.post.tags.join(",")
                        }
                    }
                );
                const tags = await response.json();
                const tagData = tags.map((tag) => ({
                    name: tag.name,
                    slug: tag.slug
                }));
                setTagNames(tagData);
            } catch (error) {
                console.error("Erreur lors de la récupération des tags :", error);
            }
        };

        if (state.post) {
            fetchTags();
        }
    }, [state.post]);

    useEffect(() => {
        const fetchRelatedPosts = async () => {
            if (!state.post?.id) return;

            try {
                const wpCategories = process.env.REACT_APP_WP_CATEGORIES;
                const url = `${process.env.REACT_APP_WP_API_URL_V1}/related-posts/${state.post.id}?categories=${wpCategories}`;
                const { data } = await axios.get(url);
                setRelatedPosts(data);
            } catch (error) {
                console.error("Error loading related posts:", error);
                setRelatedPosts([]);
            }
        };

        fetchRelatedPosts();
    }, [state.post]);

    return (
        <>
            <span className="header-span"></span>
            <Header />
            <MobileMenu />

            {state.error && (
                <div>{state.error}</div>
            )}

            {state.post && (
                <Seo pageTitle="blog"
                     pageDescription={`Blog Groupe Talent Handicap Formation - ${Parser(state.post.title.rendered)}`}
                     pageUrl={window.location.href} />
            )}

            {state.loading && (
              <LoaderAnimation />
            )}

            <div className={`blog-slug-outer ${!state.loading ? 'blog-slug-show' : ''}`}>
                <div className="auto-container">
                    {state.post && (
                        <div className="row layout-pt-20 layout-pb-20">
                            <div className="content-column col-lg-8 col-md-12 col-sm-12">
                                <div className="job-detail">
                                    <div className="layout-pt-20">
                                        {categoryNames.map((name, index) => (
                                            <div key={index} className="theme-btn btn-style-three small"
                                                 style={{marginRight: "10px", cursor: "default"}}>
                                                {name}
                                            </div>
                                        ))}
                                        <h1 className="blog-title layout-pt-20">{Parser(state.post.title.rendered)}</h1>
                                        <div className="layout-pt-20 job-detail blog-description landing-page multicolor">
                                            <div dangerouslySetInnerHTML={{__html: state.post.content.rendered}}/>
                                        </div>
                                        {tagNames.length > 0 ? (
                                            <div className="tags">
                                                <b>Mots clés : </b>
                                                {tagNames.map((tag, index) => (
                                                    <Link to={`/blog/tag/${tag.slug}`} key={index}>{tag.name}</Link>
                                                ))}
                                            </div>
                                        ) : (
                                            <></>
                                        )}

                                        <div className="auteur">
                                            <b>Par {state.post.author_info?.name || 'Talents Handicap'}</b> |
                                            le <DateDisplay date={state.post.date}/>
                                        </div>
                                        <div className="biography">
                                            <img src="/images/logoTH-2024.svg" alt=""/>
                                            Expert en recrutement inclusif et emploi des personnes en situation de
                                            handicap, Talents Handicap vous accompagne avec des conseils et ressources
                                            pratiques
                                            pour maximiser vos opportunités professionnelles.
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="sidebar-column col-lg-4 col-md-12 col-sm-12">
                                <aside className="sidebar layout-pt-60">
                                    <div className="sidebar-widget">
                                        <div className="widget-content">
                                            <div className="widget-title">
                                                <span>Rechercher</span>
                                            </div>
                                            <SearchWidget/>
                                        </div>
                                    </div>
                                    <div className="sidebar-widget">
                                        <div className="widget-content">
                                            <div className="widget-title">
                                                <span>Les derniers articles</span>
                                            </div>
                                            <WordpressApi2/>
                                        </div>
                                    </div>
                                    <div className="sidebar-widget">
                                        <div className="widget-content">
                                            <div className="widget-title">
                                                <span>Les catégories</span>
                                            </div>
                                            <CategoriesList/>
                                        </div>
                                    </div>

                                    <ShareArticle
                                        url={window.location.href}
                                        title={Parser(state.post.title.rendered)}
                                    />
                                </aside>
                            </div>

                            <RelatedPosts relatedPosts={relatedPosts} />
                        </div>
                    )}
                </div>
            </div>

            <FooterDefault footerStyle="style-six alternate -type-11"/>
        </>
    );
};
